<div class="access-denied">
  <h1 class="access-denied__title">Revolution in Rate Management</h1>
  <p class="access-denied__description">Contact your administrator to learn if your company has access to this <br/>
    Quantuvis product. Learn more at <a href="https://www.quantuvis.net/">https://www.quantuvis.net/</a>
  </p>
  <img src="/assets/angular-components-common/images/cloud-storage.png" class="access-denied__image" alt="Cloud Storage">
</div>
